// Youssef Selkani
// 2019

import React, { Component } from 'react'
import { Container, Grid, Segment, Form, Placeholder, Button, Label } from 'semantic-ui-react'
import fire from '../config/Fire'
import '../App.css'
var FontAwesome = require('react-fontawesome')

export default class Maker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      screens: []
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore
        })
        this.viewScreens()
        this.checkNavigation()
      } else {
        this.props.history.push('/')
      }
    })
  }

  viewScreens = (e) => {
    let { userUnderscore } = this.state
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/screens', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          if (json.empty === true) {
            this.setState({ loading: false, empty: true })
          } else {
            let sorted = json.screens.sort((a, b) =>
              a.rank > b.rank ? 1 : b.rank > a.rank ? -1 : 0
            )
            this.setState({
              screens: sorted,
              startingScreen: json.startingScreen,
              loading: false
            })
          }
        } else {
          this.setState({ error: 'Internal Server Error | code 500', loading: false })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  checkNavigation = (e) => {
    let { userUnderscore } = this.state
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/navigation', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if (json.code === 200) {
          this.setState({
            startingScreen: json.startingScreen
          })
        } else {
          this.setState({
            noMenu: true
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message
        })
      })
  }

  newScreen = (e) => {
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/new/screen', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        screenName: this.state.screenName
      })
    }).then((response) => {
      if (response.status === 200) {
        this.setState({ loading: false, screenName: null, empty: false })
        this.viewScreens()
      } else {
        this.setState({ error: response.status, loading: false })
      }
    })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, edit: true })
  }

  render () {
    let { error, loading, edit, screens, empty, startingScreen, noMenu } = this.state
    const screensList = this.state.screens.map((item, index) => (
      <Segment padded className='center' key={index}>
        <a style={{ color: '#000' }} href={'/edit/screen/' + item.id}>
          <h3>
            {item.icon && (
              <FontAwesome name={item.icon} color='black' style={{ marginRight: 12 }} />
            )}
            {item.name}
          </h3>
        </a>
        {item.id === startingScreen && (
          <Label style={{ fontSize: '10px' }} corner='left' icon='power' color='black' />
        )}
      </Segment>
    ))
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <h2>Screens</h2>
        </div>

        <Grid reversed='mobile' centered stackable verticalAlign='top' fluid>
          <Grid.Column width='2' />
          <Grid.Column width='8'>
            {empty && !loading && (
              <Segment placeholder textAlign='center' style={{ backgroundColor: '#fff' }}>
                <h3>Such empty!</h3>
              </Segment>
            )}
            {loading && (
              <Placeholder fluid>
                <Placeholder.Header image>
                  <Placeholder.Line length='medium' />
                  <Placeholder.Line length='short' />
                </Placeholder.Header>
                <Placeholder.Paragraph>
                  <Placeholder.Line length='long' />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line />
                </Placeholder.Paragraph>
              </Placeholder>
            )}
            {screens && !loading && screensList}
          </Grid.Column>
          <Grid.Column width='4'>
            <div className='screen-card'>
              <Segment fluid basic>
                <h3>New screen</h3>
                <Form size='large' fluid>
                  <Form.Input
                    type='text'
                    fluid
                    onChange={this.handleChange}
                    placeholder='Screen name'
                    name='screenName'
                  />
                  <Form.Button
                    onClick={this.newScreen}
                    loading={loading}
                    color='black'
                    disabled={loading || !edit}>
                    {!error ? 'Submit' : 'Error: ' + error}
                  </Form.Button>
                </Form>
              </Segment>
            </div>
            {noMenu && (
              <div className='mts'>
                <Button href='/maker/navigation' color='black' basic fluid>
                  Configure your menu
                </Button>
              </div>
            )}
          </Grid.Column>
          <Grid.Column width='2' />
        </Grid>
      </Container>
    )
  }
}
